import { render } from "./AuthLayout.vue?vue&type=template&id=764fd44a&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=764fd44a&lang=scss&scoped=true"

import exportComponent from "/home/beta/domains/architect-beta.youniversity.be/public_html/architect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764fd44a"]])

export default __exports__